import { Loader } from "lucide-react";
import { FC } from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDeleteSKUMutation } from "@/data/mutations";
import { useDialogState } from "@/hooks/use-dialog-state";

type Props = {
  skuId: string;
};

// TODO: Add number of tags that will be deleted.
export const DeleteSKUDialog: FC<Props> = ({ skuId }) => {
  const { dialog, closeDialog } = useDialogState();
  const deleteSKUMutation = useDeleteSKUMutation();

  const handleSubmit = () => {
    deleteSKUMutation.mutate(skuId);
  };

  return (
    <AlertDialog open={dialog?.name === "delete-sku"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete SKU {skuId}</AlertDialogTitle>
          <AlertDialogDescription>
            SKU {skuId} and all associated tags will be deleted and will not be
            verifiable by Legitimate or used in the future. The tags cannot be
            reassigned, reprogrammed, or erased after the SKU is deleted. This
            action is irreversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={closeDialog}
            disabled={deleteSKUMutation.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={deleteSKUMutation.isPending}
          >
            {deleteSKUMutation.isPending ? (
              <Loader className="animate-spin" />
            ) : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
